import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../../components/ui/dialog';
import { Trash2 } from 'lucide-react';

const DeleteConfirmDialog = ({ target, confirmText, setConfirmText, busy, onCancel, onConfirm }) => (
  <Dialog open={!!target} onOpenChange={(v) => { if (!v) onCancel(); }}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <DialogTitle className="text-rose-800">
          Delete {target?.kind === 'lot' ? 'Lot' : 'Piece'} — this cannot be undone
        </DialogTitle>
        <DialogDescription>
          {target?.kind === 'lot'
            ? 'All pieces in this lot will revert to In Stock. The lot record will be deleted.'
            : 'This piece will be permanently removed.'}
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3">
        <div className="text-xs text-slate-600">
          Type <b className="font-mono">{target?.label}</b> below to confirm:
        </div>
        <Input
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder={target?.label || ''}
          className="h-11 text-base font-mono"
          data-testid="delete-confirm-input"
          autoFocus
        />
      </div>
      <div className="flex gap-2 pt-2">
        <Button variant="outline" onClick={onCancel} className="flex-1 h-11">
          Cancel
        </Button>
        <Button
          variant="destructive"
          disabled={busy || confirmText.trim() !== (target?.label || '__nope__')}
          onClick={onConfirm}
          className="flex-1 h-11"
          data-testid="delete-confirm-btn"
        >
          <Trash2 className="w-4 h-4 mr-2" /> {busy ? 'Deleting…' : 'Delete'}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default DeleteConfirmDialog;
